"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  id: 0,
  dispatch: function dispatch() {}
});

exports.default = _default;
module.exports = exports.default;